import { type NavigationGuardWithThis, type RouteLocationNormalized } from 'vue-router'
import NoModuleAccess from '~/pages/general/no-module-access/Index.vue'
import { ModuleCheck, PrivilegeCheck } from '~/composables/usePermissionCheck'

const checkACLGuard: NavigationGuardWithThis<undefined> = (to) => {
  if (checkRequiredModule(to) && checkRequiredPrivilege(to)) {
    return
  }

  to.matched[to.matched.length - 1].components = { default: NoModuleAccess }
}

const checkRequiredModule = (to: RouteLocationNormalized): boolean => {
  if (!to.meta.requiredModule) {
    return true
  }

  return ModuleCheck.hasAccess(to.meta.requiredModule)
}

const checkRequiredPrivilege = (to: RouteLocationNormalized): boolean => {
  if (!to.meta.requiredPrivilege) {
    return true
  }

  return PrivilegeCheck.hasPrivilege(to.meta.requiredPrivilege)
}

export default checkACLGuard
